import { map } from 'lodash';
import React, { useCallback } from 'react';
import { useMutation } from 'react-apollo';
import SpinnerError from '../../../common/components/utils/SpinnerError';
import useQuickAccessBar, { quickAccessBarQuery, } from '../../../common/data/hooks/useQuickAccessBar';
import useUserPreferences from '../../../common/data/hooks/useUserPreferences';
import CustomizeQuickAccessBarForm from './CustomizeQuickAccessBarForm';
import updateQuickAccessBarMutation from './data/updateQuickAccessBarMutation.graphql';
const CustomizeQuickAccessBar = () => {
    const { accessList } = useUserPreferences();
    const { loading, error, quickAccessBar } = useQuickAccessBar();
    const [updateQuickAccessBar, mutationRes] = useMutation(updateQuickAccessBarMutation, {
        refetchQueries: [{ query: quickAccessBarQuery }],
    });
    const handleSubmit = useCallback(async ({ accessItems }) => {
        await updateQuickAccessBar({
            variables: {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                params: { modules: map(accessItems, ({ id, ...item }) => item) },
            },
        });
    }, [updateQuickAccessBar]);
    return (<SpinnerError error={error} firstLoading={loading} inline={false} loading={loading || mutationRes.loading}>
      <CustomizeQuickAccessBarForm accessList={accessList} entity={{ accessItems: quickAccessBar }} entityName="customize-quick-access-bar-form-new" onSubmit={handleSubmit}/>
    </SpinnerError>);
};
export default CustomizeQuickAccessBar;
